import { useState, FormEvent } from 'react';
import { authService } from '../services/authService';

export function usePasswordReset(email: string) {
  const [resetSuccess, setResetSuccess] = useState<boolean | null>(null);

  const handlePasswordReset = async (event: FormEvent) => {
    event.preventDefault();
    try {
      await authService.resetPassword(email);
      setResetSuccess(true);
    } catch {
      setResetSuccess(false);
    }
  };

  const reset = () => setResetSuccess(null);

  return { resetSuccess, handlePasswordReset, reset };
}
